import { c as _c } from "react/compiler-runtime";
import getPageType, { PageType } from '@spa/lib/tracking/getPageType';
import { PageTemplate } from '@spa/lib/cms/const';
import selectPageTemplate from '@spa/lib/store/router/selectors/selectPageTemplate';
import { usePathname } from 'next/navigation';
import { useSelector } from 'react-redux';
const useFilterActionPageType = () => {
  const $ = _c(3);
  const pathname = usePathname();
  const pageTemplate = useSelector(selectPageTemplate);
  let t0;
  if ($[0] !== pageTemplate || $[1] !== pathname) {
    t0 = getPageType({
      pathname,
      pageTemplate
    });
    $[0] = pageTemplate;
    $[1] = pathname;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
export default useFilterActionPageType;